import { useMemo } from 'react';
import { useSubscriptionManagerContext } from '../../SubscriptionManager.context';
import { resolvePaymentMethodRoles } from './PaymentMethodRoles.functions';
import { tPaymentMethodRoles } from './PaymentMethodRoles.types';

/**
 * RET-2027 — the plan's card and, when it is a different card, the customer
 * default (what one-off charges use), out of the payment methods the
 * subscription manager already loaded. No request of its own.
 */
export default function usePaymentMethodRoles(): tPaymentMethodRoles {
  const { paymentMethods, paymentMethodDefaults } =
    useSubscriptionManagerContext();

  return useMemo(
    () =>
      resolvePaymentMethodRoles({
        paymentMethods: paymentMethods ?? [],
        defaults: paymentMethodDefaults ?? {},
      }),
    [paymentMethods, paymentMethodDefaults],
  );
}
